import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./auth/authSlice";
import ecSdkReducer from "./ecSdk/ecSdkSlice";

const rootReducer = combineReducers({
    auth: authReducer,
    ecSdk: ecSdkReducer
})

export default rootReducer;